import React from "react";
import "../style/Product.css";

const services = [
  { 
    title: "Custom Corrugated Boxes", 
    icon: "📦", 
    backContent: "Strong, durable, and customizable to your specific product dimensions and branding needs" 
  },
  { 
    title: "Heavy-Duty Boxes Specialized", 
    icon: "💪", 
    backContent: "Designs to provide superior protection for sensitive or heavy products." 
  },
  { 
    title: "Folding Cartons", 
    icon: "🗂️", 
    backContent: "Lightweight yet sturdy packaging for retail-ready products." 
  },
  { 
    title: "Printed Packaging", 
    icon: "🖨️", 
    backContent: "High definition printing solutions to enhance your product’s visual appeal and brand messaging." 
  },
  { 
    title: "Smart Packaging Solutions", 
    icon: "🤖", 
    backContent: "Innovating with features like QR codes, RFID tags, and interactive designs to provide an enhanced consumer experience." 
  }
];

const Product: React.FC = () => {
  return (
    <div className="product">
      <h1 className="product_title">Our Products</h1>

      <div className="product_content">
        {services.map((service, index) => (
          <div className="service_card flip_card" key={index}>
            <div className="flip_card_inner">
              <div className="flip_card_front">
                <div className="service_icon">{service.icon}</div>
                <h3>{service.title}</h3>
              </div>
              <div className="flip_card_back">
                <p>{service.backContent}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Product;
